<div class="flex flex-col justify-center items-center max-width-lg faq-support-buttons">
  <div class="flex flex-row">
    <div class="flex-row ml-auto buttons-wrapper">
      <button class="faq-support faq-border h-40" (click)="onFaqClick()">
        <div class="flex-row pl-10 pr-10">
          <span class="mat-subtitle-2 m-auto">{{'BUTTONS.FAQ' | transloco}}</span>
        </div>
      </button>
      <button class="ml-2 faq-support support-border h-40" (click)="onSupportClick()">
        <div class="flex-row pl-10 pr-10">
          <span class="mat-subtitle-2 m-auto">{{'BUTTONS.SUPPORT' | transloco}}</span>
        </div>
      </button>
    </div>
  </div>
</div>